/** Fired after any task write succeeds; task links in notes refresh their status (#324). */
export const TASKS_CHANGED_EVENT = 'dossier:tasks-changed';
